define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ComponentEventStore = exports.ScopedEventStore = void 0;
    class ScopedEventStore {
        constructor() {
            this.publish = (event, componentInfo) => {
                this.subscribable.notifySubscribers({ event, componentInfo });
            };
            this.subscribe = (eventType, callback) => {
                return this.subscribable.subscribe((data) => {
                    if (data.event instanceof eventType)
                        callback(data.event, data.componentInfo);
                });
            };
            this.subscribable = new ko.subscribable();
        }
    }
    exports.ScopedEventStore = ScopedEventStore;
    class ComponentEventStore {
        constructor(componentInfo, masterBus) {
            this.publish = (event) => {
                this.masterBus.publish(event, this.componentInfo);
            };
            this.subscribe = (eventType, callback) => {
                this.subscriptions.push(this.masterBus.subscribe(eventType, (event, ci) => callback(event, ci)));
            };
            this.dispose = () => {
                this.subscriptions.forEach(sub => sub.dispose());
            };
            this.componentInfo = componentInfo;
            this.masterBus = masterBus;
            this.subscriptions = [];
        }
    }
    exports.ComponentEventStore = ComponentEventStore;
});
//# sourceMappingURL=store.js.map